import { render, staticRenderFns } from "./ApplicantFormStep10.vue?vue&type=template&id=cd6d2f12&scoped=true"
import script from "./ApplicantFormStep10.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6d2f12",
  null
  
)

export default component.exports